import { IWarboxMessageInitialContext } from '../types';
import { DEFAULT_WARBOX_MESSAGE_STATE } from './defaultState';

export const DEFAULT_WARBOX_MESSAGE_CONTEXT: IWarboxMessageInitialContext = {
    ...DEFAULT_WARBOX_MESSAGE_STATE,
    clearState: () => {},
    setLoading: () => {},
    getMessagesByConversation: async () => undefined,
    getMessages: async () => undefined,
    sendTextMessage: async () => undefined,
    sendTemplateMessage: async () => undefined,
    upsertMessage: () => {},
    updateNoteMessage: async () => undefined,
    deleteNoteMessage: async () => undefined,
    clearConversationMessages: async () => undefined,
};
